import { useEffect, useState } from 'react';

/**
 * Subscribes to a CSS media query.
 *
 * For layouts that cannot be expressed in CSS alone — picking between two
 * different components, say. Prefer Tailwind's responsive prefixes when the
 * difference is only styling: rendering both variants and hiding one duplicates
 * the DOM and re-runs whatever queries the hidden copy's hooks make.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    // Re-read on mount as well: the query may have changed between the initial
    // state and this effect running.
    update();
    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, [query]);

  return matches;
};

/** Tailwind's `lg` breakpoint, where the contacts filter becomes a side panel. */
export const LG_BREAKPOINT = '(min-width: 1024px)';
